export const FLAG_HOMEPAGE_FIX_HORIZONTAL_SCROLL = 'flag-homepage-fix-horizontal-scroll';

export function isHomepageFixHorizontalScrollEnabled(vueInstance) {
    const api = vueInstance && vueInstance.$api ? vueInstance.$api : window.$zoeziapi;
    if (api && typeof api.hasFlag === 'function') {
        return api.hasFlag(FLAG_HOMEPAGE_FIX_HORIZONTAL_SCROLL);
    }
    return false;
}
